
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as EventsIcon } from "../fontello/icons/svg/ic_events.svg"


const Events = ({ ...props }) => (
  <SvgIcon
    component={EventsIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Events
